import type { RefObject } from 'react'
import { useRef } from 'react'

/** Initializes value lazily via closure */
export const useRefLazy = <R>(init: () => R): RefObject<R> => {
  const run = useRef(false)
  const ref = useRef<R>(null as any as R)
  if (!run.current) {
    run.current = true
    ref.current = init()
  }
  return ref
}
